module.exports = __webpack_public_path__ + "img/green_100.7c334010.png";